<template>
  <m-modal
    :visible.sync="visible"
    @ok="$emit('handleCancel')"
    @cancel="$emit('handleCancel')"
  >
    <m-form ref="form" :model="form" label-width="180px">
      <span style="font-weight: bold">
        {{ `${$t('apply.title.fillData')}` }}
      </span>
      <div v-for="(item, index) in documentTypes" :key="index">
        <m-page-header
          :title="$localized(item, 'name')"
          class="headerStyle"
        ></m-page-header>
        <m-divider style="margin: 0px" />
      </div>

      <div style="display: flex; flex-direction: row;align-items: center;
          justify-content: center;">
        <m-checkbox v-model="checked" style="margin-top: 5px"> </m-checkbox>
        <span style="margin-left: 10px; margin-top: 5px;font-size: 14px">
          {{ $t('apply.title.notRemind') }}
        </span>
      </div>

    </m-form>
    <div slot="footer" class="dialog-footer">
      <m-button type="primary" @click="$emit('handleCancel', checked)">{{
        $t('Common.action.confirm')
      }}</m-button>
    </div>
  </m-modal>
</template>
  
  <script>
export default {
  computed: {},
  props: {
    data: Object,
    documentTypes: [],
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      checked: false
    };
  },
  methods: {
    handleOk() {},
    async onSubmit() {},
  },
  watch: {
    data: {
      immediate: true, // 很重要！！！
      handler(val) {
        this.form = val ? { ...val } : {};
      },
    },
  },
};
</script>
  <style lang="scss" scoped>
.headerStyle :deep(.m-page-header-title) {
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>
  